<template>
  <div>
    <Menu />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'

export default {
  components: {
    Menu,
    Footer,
  },
  metaInfo: {
    title: 'Vacinas nascimento divergente',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
